// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL_DEVELOPMENT = "https://api.amigogroup.id/poin-apis/setup-poin";
const API_URL_PRODUCTION = "https://backend.amigogroup.net/poin-api/api/setup-poin";

export default class SetupPoinAPIService {
  constructor() {}
  config = this.$session.get("jwt");
  static getURL = () => {
    return Properties.BUILD_TYPE == "production" ? API_URL_PRODUCTION : API_URL_DEVELOPMENT;
  }

  static nextSetup = () =>
    apiClient.get(this.getURL() + "/next", {
    });

  static current = () =>
    apiClient.get(this.getURL() + "/latest", {
    });

  static create = (setup) =>
    apiClient.post(this.getURL() + "/", setup, {
    });

  static delete = (id, nik) =>
    apiClient.delete(this.getURL() + "/" + id, {
      params: {
        user_update: nik,
      },
    });
}
